<template>
    <div>
        <creator-gallery-guide-content />

        <div class="text-center branded py-3">
            <font-awesome-icon icon="fa-light fa-arrow-down" size="2x" />
        </div>

        <b-btn @click="createGallery" variant="primary" pill block size="lg">
            {{ $t("Create My First Gallery") }}
        </b-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";

import CreatorGalleryGuideContent from "@/components/creator/gallery/CreatorGalleryGuideContent";

export default {
    computed: {
        ...mapState("creatorGuide", ["currentGuide", "guides"]),
        modal: {
            get() {
                return this.$store.state.creatorGuide.currentGuide
                    ? true
                    : false;
            },
            set(value) {
                if (!value) {
                    this.$store.commit("creatorGuide/reset");
                }
            },
        },
    },
    methods: {
        createGallery() {
            this.$router.push({ name: "creatorGallery" });
            this.$store.commit("creatorGuide/reset");
        },
    },
    components: {
        CreatorGalleryGuideContent,
    },
};
</script>